import { Dog } from "lucide-react";
import { ItemTile } from "../ItemTile";

export const BillingMirrorCart = ({ cart, showColumnHeaders, petSpecies, hasMembership }) => {
  const showHeaderBadge = cart.type === "delivery";
  const renderPetIcon = () => {
    if (showHeaderBadge) return <img src="/delivery.svg" />;
    if (petSpecies === "Cat") return <img src="/cat.svg" />;
    return <Dog color="#f05b72" />;
  };

  return (
    <div>
      <div className="grid grid-cols-[2fr_1fr_1fr_1fr_0.8fr] items-center mb-4 mt-[35px]">
        <div className="flex items-center gap-3 ml-7">
          {renderPetIcon()}
          <p className="font-medium text-[22px] whitespace-nowrap">{cart.title}</p>
          {/* {showHeaderBadge && (
            <span className="bg-[#FFDAE0] text-[#F05B72] pr-[5px] pb-[5px] pt-[5px] pl-[7px] text-[16px] font-medium rounded-tl-[20px] rounded-br-[20px] ml-5 whitespace-nowrap">
              Delivery in 2 hours
            </span>
          )} */}
        </div>
        {showColumnHeaders ? (
          <>
            <p className={`text-[20px] text-center ${hasMembership ? "ml-52 pr-10" : "ml-48"}`}> UNIT </p>
            <p className={`text-[20px] ${hasMembership ? "text-center" : "text-right mr-10 "}`}>UNIT PRICE</p>
            <p className={`text-[20px] ${hasMembership ? "text-center ml-12" : "text-right mr-12"}`}>TOTAL</p>
            <p className="text-[20px] text-right mr-8">DISCOUNT</p>
          </>
        ) : (
          <>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </>
        )}
      </div>
      <div className="flex flex-col gap-4">
        {cart.items.map((item, i) => (
          <ItemTile key={i} index={i + 1} item={item} hasMembership={hasMembership} />
        ))}
      </div>
    </div>
  );
};
